import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Button, Table, Icon } from 'antd'

@inject((store: any) => {
    const { insuranceCalculatorStore, popupStore } = store
    return { insuranceCalculatorStore, popupStore }
})
@observer
export default class InsuranceCalculatorComparasionsPopup extends Component<any, any> {
    handleShowRightsPopup = async () => {
        const { popupStore, insuranceCalculatorStore } = this.props
    }
    closePopup = () => {
        this.props.popupStore.togglePopup('insuranceCalculatorRights')
    }
    render() {
        const { popupStore, insuranceCalculatorStore } = this.props
        let { name, parameters, comparisons, index } = insuranceCalculatorStore
        parameters = JSON.parse(JSON.stringify(parameters)).sort((a, b) => {
            if (a.group < b.group) {
                return -1
            }
            if (a.group > b.group) {
                return 1
            }
            return 0
        })
        comparisons = JSON.parse(JSON.stringify(comparisons))
        let comparison1 = comparisons.names ? comparisons.names[index][0] : ''
        let comparison2 = comparisons.names ? comparisons.names[index][1] : ''
        const columns = [
            {
                title: 'שם הפרמטר',
                key: 'id',
                align: 'right',
                width: 550,
                textWrap: 'word-break',
                render: (_, obj) => <span>{obj.param}</span>
            },
            {
                title: 'שם הקבוצה',
                key: 'id',
                align: 'right',
                width: 500,
                textWrap: 'word-break',
                render: (_, obj) => <span>{obj.group}</span>
            },
            {
                title: 'דומה',
                key: 'index',
                align: 'right',
                width: 350,
                textWrap: 'word-break',
                render: (_, obj) => <span>{obj.diff ? '' : obj.val}</span>
            },
            {
                title: 'שונה',
                key: 'diff',
                align: 'right',
                width: 500,
                textWrap: 'word-break',
                render: (_, obj) => {
                    if (obj.diff) {
                        let val1 = obj.val1 ? `${comparison1}: ${obj.val1}` : false
                        let val2 = obj.val2 ? `${comparison2}: ${obj.val2}` : false
                        if (val1 && val2) {
                            return (
                                <span>
                                    {val1} <br /> {val2}
                                </span>
                            )
                        } else if (val1) {
                            return <span>{val1}</span>
                        } else {
                            return <span>{val2}</span>
                        }
                    }
                }
            }
        ]
        return (
            <Modal
                title={'שם הזכות:' + ' ' + name}
                visible={popupStore.popupType === 'insuranceCalculatorParamsPopup'}
                closeIcon={<Icon type="right" />}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={null}
                width={1400}
            >
                <div style={{ paddingBottom: '2rem' }}>
                    <Table
                        className="center-table"
                        style={{ width: '100%' }}
                        columns={columns}
                        dataSource={parameters}
                    />
                    <div style={{ display: 'flex', marginBottom: '1rem' }}></div>
                </div>
            </Modal>
        )
    }
}
